export const Market = '1';
export const Limit = '2';
export const Stop = '3';
export const StopLimit = '4';
export const MarketOnClose = '5';
export const WithOrWithout = '6';
export const LimitOrBetter = '7';
export const LimitWithOrWithout = '8';
export const OnBasis = '9';
export const OnClose = 'A';
export const LimitOnClose = 'B';
export const ForexMarket = 'C';
export const PreviouslyQuoted = 'D';
export const PreviouslyIndicated = 'E';
export const ForexLimit = 'F';
export const ForexSwap = 'G';
export const ForexPreviouslyQuoted = 'H';
export const Funari = 'I';
export const MarketIfTouched = 'J';
export const MarketWithLeftOverAsLimit = 'K';
export const PreviousFundValuationPoint = 'L';
export const NextFundValuationPoint = 'M';
export const Pegged = 'P';
export const CounterOrderSelection = 'Q';
